// import React from 'react' // Not needed in this file
import {HiLink, HiExternalLink, HiChat} from 'react-icons/hi'
import {MdColorize} from 'react-icons/md'

import { internalPages } from '../structure/deskStructure'
import ColorInput from '../components/ColorInput'
import {BlockAnnotationProps, ObjectSchemaType} from 'sanity'

export const internalLink = {
  title: 'Internal link',
  name: 'internalLink',
  type: 'object',
  blockEditor: {
    icon: HiLink,
  },
  fields: [
    {
      name: 'internalPage',
      type: 'reference',
      to: internalPages.map((p) => ({type: p})),
      options: {
        disableNew: true,
      },
    },
  ],
}

export const externalLink = {
  title: 'External Link',
  name: 'externalLink',
  type: 'object',
  blockEditor: {
    icon: HiExternalLink,
  },
  fields: [
    {
      title: 'URL',
      name: 'href',
      type: 'url',
      validation: (Rule: any) =>
        Rule.uri({
          allowRelative: true,
          scheme: ['https', 'http', 'mailto', 'tel'],
        }),
    },
    {
      title: 'Open in new tab?',
      name: 'blank',
      type: 'boolean',
      initialValue: true,
    },
  ],
}

export const chatTrigger = {
  title: 'Live chat trigger',
  name: 'chatTrigger',
  type: 'object',
  description: 'Turns the selected text into a control that opens the live chat.',
  blockEditor: {
    icon: HiChat,
  },
  fields: [
    {
      title: 'Appearance',
      name: 'appearance',
      type: 'string',
      options: {
        list: [
          {title: 'Button', value: 'button'},
          {title: 'Text link', value: 'link'},
        ],
        layout: 'radio',
      },
      initialValue: 'button',
    },
  ],
}

export const textColor: ObjectSchemaType = {
  name: 'color',
  title: 'Color',
  type: 'object',
  blockEditor: {
    icon: MdColorize,
  },
  fields: [
    {
      name: 'color',
      title: 'Color',
      type: 'string',
      components: {
        input: ColorInput,
      },
    },
  ],

  components: {
    annotation: (props: BlockAnnotationProps) => {
      console.log(props)
      return props.renderDefault({
        ...props,
        textElement: (
          <span style={{color: (props.value?.color as string) || ''}}>{props.textElement}</span>
        ),
      })
    },
  },
}
